/**
 * Animist Avatar. "You may cast magics in your hand as Spirits with
 * power equal to their cost." A Magic card played from Animist's
 * controller's hand enters the realm as a Spirit Minion whose attack
 * and defence both equal the card's mana cost.
 *
 * Pure transform invoked at the hand → table boundary in GameBoard's
 * `addCardToTable`. Idempotent. Re-running on an already-converted
 * instance is a no-op.
 */

export function shouldCastAsSpirit(cardInstance, avatarRules) {
  if (!cardInstance || cardInstance._animistSpirit) return false;
  if (cardInstance.type !== 'Magic') return false;
  return !!avatarRules?.castMagicAsSpirit;
}

export function applyCastAsSpiritTransform(cardInstance, fullCard) {
  if (!cardInstance || cardInstance._animistSpirit) return false;

  const rawCost = fullCard?.cost ?? cardInstance.cost;
  const parsed = parseInt(rawCost, 10);
  const power = Number.isFinite(parsed) && parsed > 0 ? parsed : 0;

  cardInstance.type = 'Minion';

  const existing = Array.isArray(cardInstance.subTypes) ? cardInstance.subTypes : [];
  if (!existing.includes('Spirit')) {
    cardInstance.subTypes = [...existing, 'Spirit'];
  }

  cardInstance.baseAttack = power;
  cardInstance.baseLife = power;
  cardInstance.currentAttack = power;
  cardInstance.currentLife = power;
  cardInstance._animistSpirit = true;
  return true;
}
